// ponytail: stand-in for the <product-form> element from Shrine Pro's missing global.js.
// Only adds via AJAX when the EdgeCart drawer is on the page; EdgeCart handles one-time adds itself
// and leaves selling-plan (subscription) adds to the theme. Without EdgeCart the form submits natively.
if (typeof customElements !== 'undefined' && !customElements.get('product-form')) {
  customElements.define('product-form', class extends HTMLElement {
    connectedCallback() {
      const form = this.querySelector('form[action*="/cart/add"]');
      if (!form) return;
      form.addEventListener('submit', (e) => {
        if (e.defaultPrevented || !document.getElementById('ec-cart-drawer-app')) return;
        e.preventDefault();
        const button = form.querySelector('[name="add"]');
        button?.setAttribute('aria-disabled', 'true');
        // EdgeCart wraps fetch: it refreshes its drawer on /cart/add and shows its own error toast.
        fetch(`${window.Shopify?.routes?.root || '/'}cart/add.js`, {
          method: 'POST',
          headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body: new FormData(form),
        })
          .catch((err) => console.error('Add to cart failed:', err))
          .finally(() => button?.removeAttribute('aria-disabled'));
      });
    }
  });
}
